import React from 'react';
import styled from 'styled-components';
import { FaTelegram, FaYoutube } from 'react-icons/fa';
import { useLanguage } from '../../contexts/LanguageContext';

export const SOCIAL_LINKS = {
  telegram: 'https://t.me/CS_Legasy',
  youtube: 'https://www.youtube.com/channel/UC1DZQimmczp-RQnMNeQnHwQ',
} as const;

const SocialLinksContainer = styled.div<{ $centered?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
  justify-content: ${({ $centered }) => ($centered ? 'center' : 'flex-start')};
`;

const SocialLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  color: ${({ theme }) => theme.colors.textMuted};
  background: ${({ theme }) => theme.colors.surfaceHover};
  border: 1px solid ${({ theme }) => theme.colors.border};
  transition: all ${({ theme }) => theme.transitions.fast};

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
    border-color: ${({ theme }) => theme.colors.primary};
    transform: translateY(-1px);
  }
`;

interface SocialLinksProps {
  centered?: boolean;
  className?: string;
}

const SocialLinks: React.FC<SocialLinksProps> = ({ centered, className }) => {
  const { t } = useLanguage();

  return (
    <SocialLinksContainer $centered={centered} className={className}>
      <SocialLink
        href={SOCIAL_LINKS.telegram}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t('social.telegram')}
        title={t('social.telegram')}
      >
        <FaTelegram size={18} />
      </SocialLink>
      <SocialLink
        href={SOCIAL_LINKS.youtube}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t('social.youtube')}
        title={t('social.youtube')}
      >
        <FaYoutube size={18} />
      </SocialLink>
    </SocialLinksContainer>
  );
};

export default SocialLinks;
